import { lazy } from "react";
import Loadable from "app/components/Loadable";

const EmployeeAttendanceReportList = Loadable(
  lazy(() => import("./EmployeeAttendanceReportList")),
);

const EmployeeAttendanceReportRoutes = [
  { path: "/ems/attendance", element: <EmployeeAttendanceReportList /> },
];

export default EmployeeAttendanceReportRoutes;
